import { IState } from '../../store';

export const selectGalleryBannerAnalyticsSent = (state: IState): boolean =>
  state.newbuildingBrokerOfferBooking.galleryBannerAnalyticsSent;
